import RestApiUtils from '../apiclient/moebli/RestApiUtils'

class CacheManager {
  constructor({resource, cacheKey, loader, callback, callbackObject, ttlInSecs}) {
    this.resource = resource
    this.cacheKey = cacheKey
    this.loader = loader
    this.callback = callback
    this.callbackObject = callbackObject
    this.ttlInSecs = ttlInSecs
  }

  getObject2(context, pathParams, requestParams) {
    if (!this.resource.startsWith('/api/pub/messages'))
      console.log(this.resource, pathParams, requestParams)
    // check if object is in cache
    let objectJson = this.getObjectFromCache(this.cacheKey)
    if (objectJson) {
      if (!this.resource.startsWith('/api/pub/messages'))
        console.log(this.resource, 'in cache', objectJson)
      if (this.callbackObject) {
        this.callback(objectJson, this.callbackObject)
      }
      else {
        this.callback(objectJson)
      }
    }

    // check if object needs to be refreshed from backend
    if (this.isFetchFromRemote(this.cacheKey)) {
      console.log(this.resource, 'fetch from remote')
      RestApiUtils.get(context, this.resource, this.getObjectCallback, pathParams, requestParams)

      // check cache size and delete if more than 10Mb
      const storageUsed = CacheManager.getStorage()
      if (storageUsed > 8*1000*1000) {
        CacheManager.onDeleteStorage()
      }
    }
  }

  getObjectFromCache() {
    // if object present in session storage, then render ui
    // call backend api if cached more than x duration ago
    /*
    let objectStr = sessionStorage.getItem(this.cacheKey)
    if (objectStr) {
      try {
        let objectJson =  JSON.parse(objectStr)
        if (!this.resource.startsWith('/api/pub/messages'))
          console.log(this.resource, 'object in session storage')
        return objectJson
      } catch(e) {
        sessionStorage.removeItem(this.cacheKey)
      }
    }
    else {
    */
      // if object present in local storage, then render ui
      // but also call backend api to refresh cache
      let objectStr = localStorage.getItem(this.cacheKey)
      if (objectStr) {
        try {
          let objectJson =  JSON.parse(objectStr)
          if (!this.resource.startsWith('/api/pub/messages'))
            console.log(this.resource, 'object in local storage')
          return objectJson
        } catch(e) {
          localStorage.removeItem(this.cacheKey)
        }
      }
    // }
    if (!this.resource.startsWith('/api/pub/messages'))
      console.log(this.resource, 'object not in cache')
    return null
  }

  isFetchFromRemote() {
    let objectStr = localStorage.getItem(this.cacheKey)
    if (objectStr) {
      // if cached within ttlInSecs then don't fetch again
      let cachedTime = localStorage.getItem(this.cacheKey + ':CachedTime')
      if (cachedTime && !this.resource.startsWith('/api/pub/messages'))
        console.log(this.resource, 'cache age: ', (Date.now()/1000 - cachedTime))
      if (cachedTime && Date.now()/1000 - cachedTime < this.ttlInSecs) {
        return false
      }
    }
    return true
  }

  getObjectCallback = (objectJson) => {
    // dont cache if error is returned
    if (!objectJson.errorList || objectJson.errorList.length === 0) {
      if (this.ttlInSecs) {
        // sessionStorage.setItem(this.cacheKey, JSON.stringify(objectJson))
        // sessionStorage.setItem(this.cacheKey + ':CachedTime', Date.now()/1000)
        localStorage.setItem(this.cacheKey, JSON.stringify(objectJson))
        localStorage.setItem(this.cacheKey + ':CachedTime', Date.now()/1000)
      }
    }
    console.log(this.resource, objectJson)
    if (this.callbackObject) {
      this.callback(objectJson, this.callbackObject)
    }
    else {
      this.callback(objectJson)
    }
  }

  static removeObject(cacheKey) {
    // sessionStorage.removeItem(cacheKey)
    localStorage.removeItem(cacheKey)
  }

  static removeByPrefix(prefix) {
    Object.keys(localStorage)
      .filter(cacheKey => cacheKey.startsWith(prefix))
      .forEach(cacheKey => {
        localStorage.removeItem(cacheKey)
      })
    /*
    Object.keys(sessionStorage)
      .filter(cacheKey => cacheKey.startsWith(prefix))
      .forEach(cacheKey => {
        sessionStorage.removeItem(cacheKey)
      })
    */
  }

  static setObject(cacheKey, objectJson) {
    // sessionStorage.setItem(cacheKey, JSON.stringify(objectJson))
    // sessionStorage.setItem(cacheKey + ':CachedTime', Date.now()/1000)
    localStorage.setItem(cacheKey, JSON.stringify(objectJson))
    localStorage.setItem(cacheKey + ':CachedTime', Date.now()/1000)
  }

  static getStorage() {
    let storageUsed = 0;
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        const value = localStorage.getItem(key);
        const itemSize = (key.length + value.length) * 2; // rough estimation
        storageUsed += itemSize;
    }
    return storageUsed
  }

  static onDeleteStorage = () => {
    for (let key in localStorage) {
      if (key === 'Session' || key === 'Session:CachedTime' || key === 'ecid')
        continue
      if (localStorage.hasOwnProperty(key))
        localStorage.removeItem(key);
    }
    CacheManager.getStorage()
  }
}

export default CacheManager
